import React from "react";
import { useMemo } from "react";

const CycleTimeSummaryCards = ({ cycleTimeData, machineCycleTimeData, machineDelayTimeData }) => {
  
    // Ortalama çevrim süresi
  const avgCycleTime = useMemo(() => {
    if (!cycleTimeData || !cycleTimeData.values || cycleTimeData.values.length === 0) {
      return 0; // Eğer veri yoksa 0 döndür
    }
    const total = cycleTimeData.values.reduce((sum, value) => sum + value, 0);
    return (total / cycleTimeData.values.length).toFixed(2); // Ortalama ve 2 ondalık
  }, [cycleTimeData]);
  // Makine çevrim süresi ortalaması
  const avgMachineCycleTime = useMemo(() => {
    if (!machineCycleTimeData || !machineCycleTimeData.values || machineCycleTimeData.values.length === 0) {
      return 0; // Eğer veri yoksa 0 döndür
    }
    const total = machineCycleTimeData.values.reduce((sum, value) => sum + value, 0);
    return (total / machineCycleTimeData.values.length).toFixed(2); // Ortalama ve 2 ondalık
  }, [machineCycleTimeData]);
// Makine gecikme süresi ortalamasını hesapla
const avgMachineDelayTime = useMemo(() => {
  if (!machineDelayTimeData || !machineDelayTimeData.values || machineDelayTimeData.values.length === 0) {
    return 0; // Eğer veri yoksa 0 döndür
  }
  const total = machineDelayTimeData.values.reduce((sum, value) => sum + value, 0);
  return (total / machineDelayTimeData.values.length).toFixed(2); // Ortalama ve 2 ondalık
}, [machineDelayTimeData]);

  const cycleTimeSummaries = [
    { title: "Ortalama Çevrim Süresi", value: avgCycleTime },
    { title: "Ortalama Makine Çevrim Süresi", value: avgMachineCycleTime },
    { title: "Ortalama Ürün Çevrim Süresi", value: avgMachineDelayTime },
  ];
  
  return (
    <div className="grid grid-cols-1 sm:grid-cols-3 gap-6 mt-6">
      {cycleTimeSummaries.map((summary, index) => (
        <div
          key={index}
          className="bg-white rounded-lg shadow-md p-6 border border-gray-200"
        >
          <h3 className="text-center text-sm font-semibold text-gray-500">{summary.title}</h3>
          <hr className="my-2 border-gray-300" />
          <p className="text-center text-2xl font-bold text-gray-800">{summary.value}</p>
        </div>
      ))}
    </div>
  );
};

export default CycleTimeSummaryCards;
